import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_profit_center_RowClass} from '../../dbschema';

export class ProfitCenterContainerModel extends BaseContainerModel {
  bl_fi_mst_profit_center: bl_fi_mst_profit_center_RowClass = new bl_fi_mst_profit_center_RowClass();
}
